import { FC } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AIAssistanRes } from '../service/aiAssistant.service';
import React from 'react';

interface ExpertModeProps {
  data: NonNullable<AIAssistanRes['reply']['content']['expert_mode']>;
}

export const ExpertMode: FC<ExpertModeProps> = ({ data }) => {
  return (
    <Accordion sx={{ marginBottom: '24px' }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='expert-mode-content'
        id='expert-mode-header'
      >
        <Typography component='span' variant='body2'>
          Expert Mode (Steps: {data.total_steps_count}, Total Time: {data.total_time_spent_sec}s)
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <List>
          {data.steps.map((step, idx) => (
            <React.Fragment key={`${idx}-${step.number}`}>
              <ListItem>
                <ListItemText
                  primary={`Step ${step.number}: ${step.name}`}
                  secondaryTypographyProps={{ component: 'div' }}
                  secondary={
                    <>
                      <Typography variant='body2'>Type: {step.details.type}</Typography>
                      <Typography variant='body2'>Model: {step.details.model ?? 'N/A'}</Typography>
                      <Typography variant='body2'>Status: {step.details.status}</Typography>
                      <Typography variant='body2'>
                        Time Spent: {step.details.time_spent_sec}s
                      </Typography>
                      <Typography variant='body2'>
                        Tokens Spent: {step.details.total_tokens_spent ?? 'N/A'}
                      </Typography>
                      {step.details.arguments?.code && (
                        <Typography variant='body2' component='div'>
                          Code:
                          <pre
                            style={{
                              backgroundColor: '#f5f5f5',
                              padding: '8px',
                              borderRadius: '4px',
                              overflowX: 'auto',
                            }}
                          >
                            <code>{step.details.arguments.code}</code>
                          </pre>
                        </Typography>
                      )}
                    </>
                  }
                />
              </ListItem>
              {idx < data.steps.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </AccordionDetails>
    </Accordion>
  );
};
